module.exports = __webpack_public_path__ + "static/InfiniteMinds_Logo_wGlow-58d77839ef41068efb4a92483c449ea2.png";